//import datos from '@/../public/datos/config.json'
//console.log('datos: ', datos)

console.log('env: ', process.env)
var base_url = window.location.origin

var datos = {}
if (process.env.NODE_ENV=="development") {
	datos.RutaBase = 'https://allboxmanager.info/allboxdemo/recursos/'
	datos.RutaPhp = 'https://allboxmanager.info/allboxdemo/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/globalbox/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/globalbox/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/zulubox/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/zulubox/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/selfboxes/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/selfboxes/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/almacenix/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/almacenix/php/'
} else {
	/*
	----------------------------------------------
	DEMO ALLBOX MANAGER
	----------------------------------------------
	*/
	//datos.RutaBase = 'https://allboxmanager.info/allboxdemo/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/allboxdemo/php/'
	
	/*
	----------------------------------------------
	CLIENTES
	----------------------------------------------
	*/
	//datos.RutaBase = 'https://allboxmanager.info/easystore/allboxtemplates/demo/'
	//datos.RutaPhp = 'https://allboxmanager.info/easystore/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/trastersbadalona/allboxtemplates/demo/'
	//datos.RutaPhp = 'https://allboxmanager.info/trastersbadalona/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/selfboxes/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/selfboxes/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/globalbox/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/globalbox/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/fejabox/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/fejabox/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/trasterosextra/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/trasterosextra/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/almacenix/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/almacenix/php/'

	//datos.RutaBase = 'https://allboxmanager.info/zulubox/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/zulubox/php/'
	
	//datos.RutaBase = 'https://allboxmanager.info/trasterosesplugues/recursos/'
	//datos.RutaPhp = 'https://allboxmanager.info/trasterosesplugues/php/'
	
	
	// Ahora todo lo que hacía arriba antes de compilar, se define en un config.txt en la página de contratación del cliente, en / y que varía para cada cliente
	// Debemos copiar también de forma manual el config.php que es igual para todos los clientes
	var xhr = new XMLHttpRequest();
	xhr.open('GET', '/config.php', false); // false hace la petición síncrona
	
	try {
		xhr.send();
		if (xhr.status === 200) {
			try {
				var config = JSON.parse(xhr.responseText);
				datos.RutaBase = config.rutaBase;
				datos.RutaPhp = config.rutaPhp;
			} catch (jsonErr) {
				console.error('Error parseando JSON: ' + jsonErr);
			}
		} else {
			console.error('Error en la solicitud: ' + xhr.status);
		}
	} catch(err) {
		console.error('Error en la solicitud: ' + err);
	}
	
}

export const RUTA_BASE = datos.RutaBase
export const RUTA_PHP = datos.RutaPhp

//AHORA TODO ESTO SE DEFINE EN PARAMETROS.JSON
//export const API_KEY = "AIzaSyAwHG1SFwndWSEfD916P4KbxgeIePIfbp4"
//export const API_KEY = "AIzaSyCETz6pDdfPUuzZD0q1BySoKpLDoJRJiZY"
//export const ALLBOX_WEB_VERSION = "2.02"    ESTO AHORA VA EN store.js
//export const PAGO_PASARELA = true            // si está a true requiere pago por pasarela para la reserva, sino envía el pedido directamente
//export const TIPO_PASARELA = "lyra"           // esta podrá ser redsys - stripe - lyra - addons

//export const SIN_DNI = false
//export const SIN_CUENTA_BANCO = false          // Esto si está a true no nos pide los datos bancarios al contratar un nuevo box


//export const CENTRO_PASARELA = 1
//export const RUTA_PASARELA = 'https://allboxprivada.erpgestion.es'
//export const RUTA_PASARELA = 'https://allboxtmp.erpgestion.es'

// PASARELA PAGO REDSYS
//export const RUTA_PASARELA_BANCO = 'https://sis-t.redsys.es:25443/sis/realizarPago' //PRUEBAS
//export const RUTA_PASARELA_BANCO = 'https://sis.redsys.es/sis/realizarPago' //PRODUCCION



